<template>
    <v-dialog max-width="500px" v-model="dialog">
        <v-card min-width="400px">
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon class="ma-1" color="red" @click="onClose">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-actions>
            <v-card-actions>
                <v-text-field v-model="newTag" style="padding:0 25px"></v-text-field>
            </v-card-actions>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                        :loading="buttonLoading"
                        class="ma-2"
                        color="primary"
                        @click="onPressUse">CHANGE
                </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import {ConfigStoreUtils} from "@/modules/mconfigs/database/ConfigStoreUtils";

export default {
    name: "c-edit-tag-popup",
    props: {},
    data: () => ({
        buttonLoading: false,
        dialog: false,
        newTag: "",
        item: null
    }),
    computed: {},
    methods: {
        show(item) {
            this.item = item
            this.newTag = this.item.tag
            this.dialog = true
        },
        hide() {
            this.dialog = true
        },
        onClose() {
            this.dialog = false
        },
        onPressUse() {
            let item = this.item.clone()
            item.tag = this.newTag
            item.deployed = false;
            this.buttonLoading = true
            ConfigStoreUtils.updateReleaseConfig(item, null).then(() => {
                this.$notify({title: 'Tag successfully changed!', text: "", type: "succes"});
                this.dialog = false
                this.buttonLoading = false
            }).catch((error) => {
                this.$notify({title: 'Tag change failed!', text: error, type: "error"});
                this.dialog = false
                this.buttonLoading = false
            })
        }
    }
}
</script>

<style scoped>

</style>